import * as React from 'react';
import customSolarIconWrapper from '../../../custom-icons';

// Placed on the shared 240x240 doodle frame: stack a body, eyes, mouth and accessory to compose a doodle
const DoodleMouthBouche5 = customSolarIconWrapper(<g transform="translate(109 154)">
	<path d="M13.1422 10.657C13.1422 9.299 12.0389 8.198 10.678 8.198C9.3171 8.198 8.2139 9.299 8.2139 10.657C8.2139 12.015 9.3171 13.116 10.678 13.116V21.314C4.7807 21.314 0 16.542 0 10.657C0 4.771 4.7807 0 10.678 0C16.5753 0 21.356 4.771 21.356 10.657C21.356 16.542 16.5753 21.314 10.678 21.314V13.116C12.0389 13.116 13.1422 12.015 13.1422 10.657Z" fill="#202020" />
</g>, { viewBox: '0 0 240 240' });

export default DoodleMouthBouche5;
